import { gql } from "apollo-angular";

export const  PORTFOLIO_CALCULATOR_FORM = gql`
  fragment PORTFOLIO_CALCULATOR_FORM on PortfolioCalculatorForm {
    portfolioCalculatorTitle
    step1Title
    step1Text
    step3Title
    step3Text
    step3ButtonText1
    step3ButtonText2
    step3ButtonAction2
    tcpaDisclaimer
    gdprDisclaimer
    gdprCheckBoxNotice
    step5Text
    step5Title
    qualificationResult1
    qualificationResult2
    qualificationResult3
    qualificationResult4
  }`;